export const FETCH_USER_TAB_SUCCESS = 'FETCH_USER_TAB_SUCCESS';
export const DUMMY_ACTION_M = 'DUMMY_ACTION_M';
